const azkarData = {
  "أذكار الصباح": [
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "أَصْـبَحْنا وَأَصْـبَحَ المُـلْكُ لله وَالحَمدُ لله ، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description:
        "من قالها موقنا بها حين يمسى ومات من ليلته دخل الجنة وكذلك حين يصبح.",
      reference: "",
      content:
        "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ ، خَلَقْتَنـي وَأَنا عَبْـدُك ، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت ، أَعـوذُبِكَ مِنْ شَـرِّ ما صَنَـعْت ، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ .",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description:
        "من قالها حين يصبح وحين يمسى كان حقا على الله أن يرضيه يوم القيامة.",
      reference: "",
      content:
        "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ صلى الله عليه وسلم نَبِيّـاً. ",
    },
    {
      category: "أذكار الصباح",
      count: "4",
      description: "من قالها أعتقه الله من النار.",
      reference: "",
      content:
        "اللّهُـمَّ إِنِّـي أَصْبَـحْتُ أُشْـهِدُك ، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك ، وَمَلَائِكَتَكَ ، وَجَمـيعَ خَلْـقِك ، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلاّ أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك ، وَأَنَّ ُ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
    },
    {
      category: "أذكار الصباح",
      count: "7",
      description: "من قالها كفاه الله ما أهمه من أمر الدنيا والأخرة.",
      reference: "",
      content:
        "حَسْبِـيَ اللّهُ لا إلهَ إلاّ هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "لم يضره من الله شيء.",
      reference: "",
      content:
        "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ بِكَ أَصْـبَحْنا وَبِكَ أَمْسَـينا ، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ النُّـشُور.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "أَصْبَـحْـنا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه ، وَرِضـا نَفْسِـه ، وَزِنَـةَ عَـرْشِـه ، وَمِـدادَ كَلِمـاتِـه.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ عافِـني في بَدَنـي ، اللّهُـمَّ عافِـني في سَمْـعي ، اللّهُـمَّ عافِـني في بَصَـري ، لا إلهَ إلاّ أَنْـتَ.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر ، وَالفَـقْر ، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر ، لا إلهَ إلاّ أَنْـتَ.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة ، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي ، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي ، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي ، وَمِن فَوْقـي ، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "يَا حَيُّ يَا قيُّومُ بِرَحْمَتِكَ أسْتَغِيثُ أصْلِحْ لِي شَأنِي كُلَّهُ وَلاَ تَكِلْنِي إلَى نَفْسِي طَـرْفَةَ عَيْنٍ.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "أَصْبَـحْـنا وَأَصْبَـحْ المُـلكُ للهِ رَبِّ العـالَمـين ، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ خَـيْرَ هـذا الـيَوْم ، فَـتْحَهُ ، وَنَصْـرَهُ ، وَنـورَهُ وَبَـرَكَتَـهُ ، وَهُـداهُ ، وَأَعـوذُ بِـكَ مِـنْ شَـرِّ ما فـيهِ وَشَـرِّ ما بَعْـدَه.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه ، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت ، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِرْكِهِ ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق.",
    },
    {
      category: "أذكار الصباح",
      count: "10",
      description: "من صلى على حين يصبح وحين يمسى ادركته شفاعتى يوم القيامة.",
      reference: "",
      content: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئًا نَعْلَمُهُ ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنْ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنْ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ، وَقَهْرِ الرِّجَالِ.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "أسْتَغْفِرُ اللهَ العَظِيمَ الَّذِي لاَ إلَهَ إلاَّ هُوَ، الحَيُّ القَيُّومُ، وَأتُوبُ إلَيهِ.",
    },
    {
      category: "أذكار الصباح",
      count: "3",
      description: "",
      reference: "",
      content:
        "يَا رَبِّ , لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ , وَلِعَظِيمِ سُلْطَانِكَ.",
    },
    {
      category: "أذكار الصباح",
      count: "1",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا.",
    },
    {
      category: "أذكار الصباح",
      count: "100",
      description:
        "كانت له عدل عشر رقاب، وكتبت له مئة حسنة، ومحيت عنه مئة سيئة، وكانت له حرزا من الشيطان.",
      reference: "",
      content:
        "لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءِ قَدِيرِ.",
    },
    {
      category: "أذكار الصباح",
      count: "100",
      description:
        "حُطَّتْ خَطَايَاهُ وَإِنْ كَانَتْ مِثْلَ زَبَدِ الْبَحْرِ. لَمْ يَأْتِ أَحَدٌ يَوْمَ الْقِيَامَةِ بِأَفْضَلَ مِمَّا جَاءَ بِهِ إِلَّا أَحَدٌ قَالَ مِثْلَ مَا قَالَ أَوْ زَادَ عَلَيْهِ.",
      reference: "",
      content: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ.",
    },
    {
      category: "أذكار الصباح",
      count: "100",
      description:
        "مائة حسنة، ومُحيت عنه مائة سيئة، وكانت له حرزاً من الشيطان حتى يمسى.",
      reference: "",
      content: "أسْتَغْفِرُ اللهَ وَأتُوبُ إلَيْهِ",
    },
  ],
  "أذكار المساء": [
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "أَمْسَيْـنا وَأَمْسـى المـلكُ لله وَالحَمدُ لله ، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير ، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذهِ اللَّـيْلَةِ وَخَـيرَ ما بَعْـدَهـا ، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذهِ اللَّـيْلةِ وَشَرِّ ما بَعْـدَهـا ، رَبِّ أَعـوذُبِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر ، رَبِّ أَعـوذُ بِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description:
        "من قالها موقنا بها حين يمسى ومات من ليلته دخل الجنة وكذلك حين يصبح.",
      reference: "",
      content:
        "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ ، خَلَقْتَنـي وَأَنا عَبْـدُك ، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت ، أَعـوذُبِكَ مِنْ شَـرِّ ما صَنَـعْت ، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ .",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description:
        "من قالها حين يصبح وحين يمسى كان حقا على الله أن يرضيه يوم القيامة.",
      reference: "",
      content:
        "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ صلى الله عليه وسلم نَبِيّـاً.",
    },
    {
      category: "أذكار المساء",
      count: "04",
      description: "من قالها أعتقه الله من النار.",
      reference: "",
      content:
        "اللّهُـمَّ إِنِّـي أَمسيتُ أُشْـهِدُك ، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك ، وَمَلَائِكَتَكَ ، وَجَمـيعَ خَلْـقِك ، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلاّ أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك ، وَأَنَّ ُ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "من قالها حين يمسى أدى شكر يومه.",
      reference: "",
      content:
        "اللّهُـمَّ ما أَمسى بي مِـنْ نِعْـمَةٍ أَو بِأَحَـدٍ مِـنْ خَلْـقِك ، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك ، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر.",
    },
    {
      category: "أذكار المساء",
      count: "07",
      description: "من قالها كفاه الله ما أهمه من أمر الدنيا والأخرة.",
      reference: "",
      content:
        "حَسْبِـيَ اللّهُ لا إلهَ إلاّ هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "لم يضره من الله شيء.",
      reference: "",
      content:
        "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ بِكَ أَمْسَـينا وَبِكَ أَصْـبَحْنا، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ الْمَصِيرُ.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "أَمْسَيْنَا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه ، وَرِضـا نَفْسِـه ، وَزِنَـةَ عَـرْشِـه ، وَمِـدادَ كَلِمـاتِـه.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ عافِـني في بَدَنـي ، اللّهُـمَّ عافِـني في سَمْـعي ، اللّهُـمَّ عافِـني في بَصَـري ، لا إلهَ إلاّ أَنْـتَ.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر ، وَالفَـقْر ، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر ، لا إلهَ إلاّ أَنْـتَ.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة ، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي ، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي ، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي ، وَمِن فَوْقـي ، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "يَا حَيُّ يَا قيُّومُ بِرَحْمَتِكَ أسْتَغِيثُ أصْلِحْ لِي شَأنِي كُلَّهُ وَلاَ تَكِلْنِي إلَى نَفْسِي طَـرْفَةَ عَيْنٍ.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "أَمْسَيْنا وَأَمْسَى الْمُلْكُ للهِ رَبِّ الْعَالَمَيْنِ، اللَّهُمَّ إِنَّي أسْأَلُكَ خَيْرَ هَذَه اللَّيْلَةِ فَتْحَهَا ونَصْرَهَا، ونُوْرَهَا وبَرَكَتهَا، وَهُدَاهَا، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فيهِا وَشَرَّ مَا بَعْدَهَا.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه ، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت ، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِرْكِهِ ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق.",
    },
    {
      category: "أذكار المساء",
      count: "10",
      description: "من صلى على حين يصبح وحين يمسى ادركته شفاعتى يوم القيامة.",
      reference: "",
      content: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئًا نَعْلَمُهُ ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنْ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنْ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ، وَقَهْرِ الرِّجَالِ.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "أسْتَغْفِرُ اللهَ العَظِيمَ الَّذِي لاَ إلَهَ إلاَّ هُوَ، الحَيُّ القَيُّومُ، وَأتُوبُ إلَيهِ.",
    },
    {
      category: "أذكار المساء",
      count: "03",
      description: "",
      reference: "",
      content:
        "يَا رَبِّ , لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ , وَلِعَظِيمِ سُلْطَانِكَ.",
    },
    {
      category: "أذكار المساء",
      count: "100",
      description:
        "كانت له عدل عشر رقاب، وكتبت له مئة حسنة، ومحيت عنه مئة سيئة، وكانت له حرزا من الشيطان.",
      reference: "",
      content:
        "لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءِ قَدِيرِ.",
    },
    {
      category: "أذكار المساء",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ أَنْتَ رَبِّي لا إِلَهَ إِلا أَنْتَ ، عَلَيْكَ تَوَكَّلْتُ ، وَأَنْتَ رَبُّ الْعَرْشِ الْعَظِيمِ , مَا شَاءَ اللَّهُ كَانَ ، وَمَا لَمْ يَشَأْ لَمْ يَكُنْ ، وَلا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ , أَعْلَمُ أَنَّ اللَّهَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ ، وَأَنَّ اللَّهَ قَدْ أَحَاطَ بِكُلِّ شَيْءٍ عِلْمًا , اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي ، وَمِنْ شَرِّ كُلِّ دَابَّةٍ أَنْتَ آخِذٌ بِنَاصِيَتِهَا ، إِنَّ رَبِّي عَلَى صِرَاطٍ مُسْتَقِيمٍ.",
    },
    {
      category: "أذكار المساء",
      count: "100",
      description:
        "حُطَّتْ خَطَايَاهُ وَإِنْ كَانَتْ مِثْلَ زَبَدِ الْبَحْرِ. لَمْ يَأْتِ أَحَدٌ يَوْمَ الْقِيَامَةِ بِأَفْضَلَ مِمَّا جَاءَ بِهِ إِلَّا أَحَدٌ قَالَ مِثْلَ مَا قَالَ أَوْ زَادَ عَلَيْهِ.",
      reference: "",
      content: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ.",
    },
  ],
  "أذكار بعد السلام من الصلاة المفروضة": [
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "",
      reference: "",
      content:
        "أَسْـتَغْفِرُ الله، أَسْـتَغْفِرُ الله، أَسْـتَغْفِرُ الله.اللّهُـمَّ أَنْـتَ السَّلامُ ، وَمِـنْكَ السَّلام ، تَبارَكْتَ يا ذا الجَـلالِ وَالإِكْـرام .",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "",
      reference: "",
      content:
        "لا إلهَ إلاّ اللّهُ وحدَهُ لا شريكَ لهُ، لهُ المُـلْكُ ولهُ الحَمْد، وهوَ على كلّ شَيءٍ قَدير، اللّهُـمَّ لا مانِعَ لِما أَعْطَـيْت، وَلا مُعْطِـيَ لِما مَنَـعْت، وَلا يَنْفَـعُ ذا الجَـدِّ مِنْـكَ الجَـد.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "",
      reference: "",
      content:
        "لا إلهَ إلاّ اللّه, وحدَهُ لا شريكَ لهُ، لهُ الملكُ ولهُ الحَمد، وهوَ على كلّ شيءٍ قدير، لا حَـوْلَ وَلا قـوَّةَ إِلاّ بِاللهِ، لا إلهَ إلاّ اللّـه، وَلا نَعْـبُـدُ إِلاّ إيّـاه, لَهُ النِّعْـمَةُ وَلَهُ الفَضْل وَلَهُ الثَّـناءُ الحَـسَن، لا إلهَ إلاّ اللّهُ مخْلِصـينَ لَـهُ الدِّينَ وَلَوْ كَـرِهَ الكـافِرون.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "33",
      description: "",
      reference: "",
      content: "سُـبْحانَ اللهِ، والحَمْـدُ لله ، واللهُ أكْـبَر.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "",
      reference: "",
      content:
        "لا إلهَ إلاّ اللّهُ وَحْـدَهُ لا شريكَ لهُ، لهُ الملكُ ولهُ الحَمْد، وهُوَ على كُلّ شَيءٍ قَـدير.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "10",
      description: "عَشْر مَرّات بَعْدَ المَغْرِب وَالصّـبْح.",
      reference: "",
      content:
        "لا إلهَ إلاّ اللّهُ وحْـدَهُ لا شريكَ لهُ، لهُ المُلكُ ولهُ الحَمْد، يُحيـي وَيُمـيتُ وهُوَ على كُلّ شيءٍ قدير.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "بَعْد السّلامِ من صَلاةِ الفَجْر.",
      reference: "",
      content:
        "اللّهُـمَّ إِنِّـي أَسْأَلُـكَ عِلْمـاً نافِعـاً وَرِزْقـاً طَيِّـباً ، وَعَمَـلاً مُتَقَـبَّلاً.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "07",
      description: "بعد صلاة الصبح والمغرب.",
      reference: "",
      content: "اللَّهُمَّ أَجِرْنِي مِنْ النَّار.",
    },
    {
      category: "أذكار بعد السلام من الصلاة المفروضة",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللَّهُمَّ أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ وَحُسْنِ عِبَادَتِكَ.",
    },
  ],
  تسابيح: [
    {
      category: "تسابيح",
      count: "100",
      description: "يكتب له ألف حسنة أو يحط عنه ألف خطيئة.",
      reference: "",
      content: "سُبْحَانَ اللَّهِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "حُطَّتْ خَطَايَاهُ وَإِنْ كَانَتْ مِثْلَ زَبَدِ الْبَحْرِ. لَمْ يَأْتِ أَحَدٌ يَوْمَ الْقِيَامَةِ بِأَفْضَلَ مِمَّا جَاءَ بِهِ إِلَّا أَحَدٌ قَالَ مِثْلَ مَا قَالَ أَوْ زَادَ عَلَيْهِ.",
      reference: "",
      content: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "تَمْلَآَنِ مَا بَيْنَ السَّمَاوَاتِ وَالْأَرْضِ.",
      reference: "",
      content: "سُبْحَانَ اللَّهِ وَالْحَمْدُ لِلَّهِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "غرست له نخلة في الجنة.",
      reference: "",
      content: "سُبْحَانَ اللهِ العَظِيمِ وَبِحَمْدِهِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "ثقيلتان في الميزان حبيبتان إلى الرحمن.",
      reference: "",
      content: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ ، سُبْحَانَ اللَّهِ الْعَظِيمِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "كانت له عدل عشر رقاب، وكتبت له مئة حسنة، ومحيت عنه مئة سيئة، وكانت له حرزا من الشيطان.",
      reference: "",
      content:
        "لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلُّ شَيْءِ قَدِيرِ.",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "كنز من كنوز الجنة.",
      reference: "",
      content: "لا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "تملأ ميزان العبد بالحسنات.",
      reference: "",
      content: "الْحَمْدُ للّهِ رَبِّ الْعَالَمِينَ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "من صلى على حين يصبح وحين يمسى ادركته شفاعتى يوم القيامة.",
      reference: "",
      content: "الْلَّهُم صَلِّ وَسَلِم وَبَارِك عَلَى سَيِّدِنَا مُحَمَّد",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "لفعل الرسول صلى الله عليه وسلم.",
      reference: "",
      content: "أستغفر الله",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "أنهن أحب الكلام الى الله، ومكفرات للذنوب، وغرس الجنة، وجنة لقائلهن من النار، وأحب الى النبي عليه السلام مما طلعت عليه الشمس، والْبَاقِيَاتُ الْصَّالِحَات.",
      reference: "",
      content:
        "سُبْحَانَ الْلَّهِ، وَالْحَمْدُ لِلَّهِ، وَلَا إِلَهَ إِلَّا الْلَّهُ، وَالْلَّهُ أَكْبَرُ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "أفضل الذكر لا إله إلاّ الله.",
      reference: "",
      content: "لَا إِلَهَ إِلَّا اللَّهُ",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "من قال الله أكبر كتبت له عشرون حسنة وحطت عنه عشرون سيئة. الله أكبر من كل شيء.",
      reference: "",
      content: "الْلَّهُ أَكْبَرُ",
    },
    {
      category: "تسابيح",
      count: "100",
      description: "خير الدنيا والآخرة",
      reference: "",
      content:
        "سُبْحَانَ اللَّهِ ، وَالْحَمْدُ لِلَّهِ ، وَلا إِلَهَ إِلا اللَّهُ ، وَاللَّهُ أَكْبَرُ ، اللَّهُمَّ اغْفِرْ لِي ، اللَّهُمَّ ارْحَمْنِي ، اللَّهُمَّ ارْزُقْنِي.",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "قَالَ النَّبِيُّ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ عَجِبْتُ لَهَا ، فُتِحَتْ لَهَا أَبْوَابُ السَّمَاءِ.",
      reference: "",
      content:
        "اللَّهُ أَكْبَرُ كَبِيرًا ، وَالْحَمْدُ لِلَّهِ كَثِيرًا ، وَسُبْحَانَ اللَّهِ بُكْرَةً وَأَصِيلاً.",
    },
    {
      category: "تسابيح",
      count: "100",
      description:
        "في كل مره تحط عنه عشر خطايا ويرفع له عشر درجات ويصلي الله عليه عشرا وتعرض على الرسول صلى الله عليه وسلم.",
      reference: "",
      content:
        "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ , وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ , اللَّهُمَّ بَارِكْ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ.",
    },
  ],
  "أذكار النوم": [
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content:
        "بِاسْمِكَ رَبِّـي وَضَعْـتُ جَنْـبي ، وَبِكَ أَرْفَعُـه، فَإِن أَمْسَـكْتَ نَفْسـي فارْحَـمْها ، وَإِنْ أَرْسَلْتَـها فاحْفَظْـها بِمـا تَحْفَـظُ بِه عِبـادَكَ الصّـالِحـين.",
    },
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ إِنَّـكَ خَلَـقْتَ نَفْسـي وَأَنْـتَ تَوَفّـاهـا لَكَ ممَـاتـها وَمَحْـياها ، إِنْ أَحْيَيْـتَها فاحْفَظْـها ، وَإِنْ أَمَتَّـها فَاغْفِـرْ لَـها . اللّهُـمَّ إِنَّـي أَسْـأَلُـكَ العـافِـيَة.",
    },
    {
      category: "أذكار النوم",
      count: "03",
      description: "",
      reference: "",
      content: "اللّهُـمَّ قِنـي عَذابَـكَ يَـوْمَ تَبْـعَثُ عِبـادَك.",
    },
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content: "بِاسْـمِكَ اللّهُـمَّ أَمـوتُ وَأَحْـيا.",
    },
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content:
        "الـحَمْدُ للهِ الَّذي أَطْـعَمَنا وَسَقـانا، وَكَفـانا، وَآوانا، فَكَـمْ مِمَّـنْ لا كـافِيَ لَـهُ وَلا مُـؤْوي.",
    },
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ عالِـمَ الغَـيبِ وَالشّـهادةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كُـلِّ شَـيءٍ وَمَليـكَه، أَشْهـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي، وَمِن شَـرِّ الشَّيْـطانِ وَشِـرْكِه، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم .",
    },
    {
      category: "أذكار النوم",
      count: "01",
      description: "",
      reference: "",
      content:
        "اللّهُـمَّ أَسْـلَمْتُ نَفْـسي إِلَـيْكَ، وَفَوَّضْـتُ أَمْـري إِلَـيْكَ، وَوَجَّـهْتُ وَجْـهي إِلَـيْكَ، وَأَلْـجَـاْتُ ظَهـري إِلَـيْكَ، رَغْبَـةً وَرَهْـبَةً إِلَـيْكَ، لا مَلْجَـأَ وَلا مَنْـجـا مِنْـكَ إِلاّ إِلَـيْكَ، آمَنْـتُ بِكِتـابِكَ الّـذي أَنْزَلْـتَ وَبِنَبِـيِّـكَ الّـذي أَرْسَلْـت.",
    },
    {
      category: "أذكار النوم",
      count: "33",
      description: "",
      reference: "",
      content: "سُبْحَانَ اللَّهِ.",
    },
    {
      category: "أذكار النوم",
      count: "33",
      description: "",
      reference: "",
      content: "الْحَمْدُ لِلَّهِ.",
    },
    {
      category: "أذكار النوم",
      count: "34",
      description: "",
      reference: "",
      content: "اللَّهُ أَكْبَرُ.",
    },
  ],
  "أذكار الاستيقاظ": [
    {
      category: "أذكار الاستيقاظ",
      count: "01",
      description: "",
      reference: "",
      content:
        "الحَمْـدُ لِلّهِ الّذي أَحْـيانا بَعْـدَ ما أَماتَـنا وَإليه النُّـشور.",
    },
    {
      category: "أذكار الاستيقاظ",
      count: "01",
      description: "",
      reference: "",
      content:
        "الحمدُ للهِ الذي عافاني في جَسَدي وَرَدّ عَليّ روحي وَأَذِنَ لي بِذِكْرِه.",
    },
    {
      category: "أذكار الاستيقاظ",
      count: "01",
      description: "",
      reference: "",
      content:
        "لا إلهَ إلاّ اللّهُ وَحْـدَهُ لا شَـريكَ له، لهُ المُلـكُ ولهُ الحَمـد، وهوَ على كلّ شيءٍ قدير، سُـبْحانَ اللهِ، والحمْـدُ لله ، ولا إلهَ إلاّ اللهُ واللهُ أكبَر، وَلا حَولَ وَلا قوّة إلاّ باللّهِ العليّ العظيم. رَبِّ اغْفرْ لي.",
    },
  ],
  "أدعية قرآنية": [
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [البقرة - 201].",
      content:
        " رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ. [البقرة - 201]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [البقرة - 250].",
      content:
        " رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَثَبِّتْ أَقْدَامَنَا وَانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ. [البقرة - 250]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [البقرة - 286].",
      content:
        " رَبَّنَا لاَ تُؤَاخِذْنَا إِن نَّسِينَا أَوْ أَخْطَأْنَا رَبَّنَا وَلاَ تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِن قَبْلِنَا رَبَّنَا وَلاَ تُحَمِّلْنَا مَا لاَ طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنتَ مَوْلاَنَا فَانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ. [البقرة - 286]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران - 8].",
      content:
        " رَبَّنَا لاَ تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً إِنَّكَ أَنتَ الْوَهَّابُ. [آل عمران - 8]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران - 16].",
      content:
        " رَبَّنَا إِنَّنَا آمَنَّا فَاغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ النَّارِ. [آل عمران - 16]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران - 38].",
      content:
        " رَبِّ هَبْ لِي مِن لَّدُنْكَ ذُرِّيَّةً طَيِّبَةً إِنَّكَ سَمِيعُ الدُّعَاء. [آل عمران - 38]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران - 53].",
      content:
        " رَبَّنَا آمَنَّا بِمَا أَنزَلْتَ وَاتَّبَعْنَا الرَّسُولَ فَاكْتُبْنَا مَعَ الشَّاهِدِينَ. [آل عمران - 53]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران - 147].",
      content:
        " ربَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَِ. [آل عمران - 147]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [آل عمران -  191-194].",
      content:
        " رَبَّنَا مَا خَلَقْتَ هَذا بَاطِلاً سُبْحَانَكَ فَقِنَا عَذَابَ النَّارِ رَبَّنَا إِنَّكَ مَن تُدْخِلِ النَّارَ فَقَدْ أَخْزَيْتَهُ وَمَا لِلظَّالِمِينَ مِنْ أَنصَارٍ رَّبَّنَا إِنَّنَا سَمِعْنَا مُنَادِيًا يُنَادِي لِلإِيمَانِ أَنْ آمِنُواْ بِرَبِّكُمْ فَآمَنَّا رَبَّنَا فَاغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّئَاتِنَا وَتَوَفَّنَا مَعَ الأبْرَارِ رَبَّنَا وَآتِنَا مَا وَعَدتَّنَا عَلَى رُسُلِكَ وَلاَ تُخْزِنَا يَوْمَ الْقِيَامَةِ إِنَّكَ لاَ تُخْلِفُ الْمِيعَادَ. [آل عمران -  191-194]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الأعراف - 23].",
      content:
        " رَبَّنَا ظَلَمْنَا أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ. [الأعراف - 23]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الأعراف - 47].",
      content:
        " رَبَّنَا لاَ تَجْعَلْنَا مَعَ الْقَوْمِ الظَّالِمِينَ. [الأعراف - 47]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الأعراف - 126].",
      content:
        " رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَتَوَفَّنَا مُسْلِمِينَ. [الأعراف - 126]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [التوبة - 129].",
      content:
        " حَسْبِيَ اللّهُ لا إِلَـهَ إِلاَّ هُوَ عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ. [التوبة - 129]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [يونس - 85-86].",
      content:
        " رَبَّنَا لاَ تَجْعَلْنَا فِتْنَةً لِّلْقَوْمِ الظَّالِمِينَ وَنَجِّنَا بِرَحْمَتِكَ مِنَ الْقَوْمِ الْكَافِرِينَ. [يونس - 85-86]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [هود - 47].",
      content:
        " رَبِّ إِنِّي أَعُوذُ بِكَ أَنْ أَسْأَلَكَ مَا لَيْسَ لِي بِهِ عِلْمٌ وَإِلاَّ تَغْفِرْ لِي وَتَرْحَمْنِي أَكُن مِّنَ الْخَاسِرِينَ. [هود - 47]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [إبرهيم - 40].",
      content:
        " رَبِّ اجْعَلْنِي مُقِيمَ الصَّلاَةِ وَمِن ذُرِّيَّتِي رَبَّنَا وَتَقَبَّلْ دُعَاء. [إبرهيم - 40]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [إبرهيم - 41].",
      content:
        " رَبَّنَا اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ. [إبرهيم - 41]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الإسراء - 80].",
      content:
        " رَّبِّ أَدْخِلْنِي مُدْخَلَ صِدْقٍ وَأَخْرِجْنِي مُخْرَجَ صِدْقٍ وَاجْعَل لِّي مِن لَّدُنكَ سُلْطَانًا نَّصِيرًا. [الإسراء - 80]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الكهف - 10].",
      content:
        " رَبَّنَا آتِنَا مِن لَّدُنكَ رَحْمَةً وَهَيِّئْ لَنَا مِنْ أَمْرِنَا رَشَدًا. [الكهف - 10]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [طه - 25-28].",
      content:
        " رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي يَفْقَهُوا قَوْلِي. [طه - 25-28]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [طه - 114].",
      content: " رَّبِّ زِدْنِي عِلْمًا. [طه - 114]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الأنبياء - 87].",
      content:
        " لا إِلَهَ إِلا أَنتَ سُبْحَانَكَ إِنِّي كُنتُ مِنَ الظَّالِمِينَ. [الأنبياء - 87]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [الأنبياء - 89].",
      content:
        " رَبِّ لَا تَذَرْنِي فَرْدًا وَأَنتَ خَيْرُ الْوَارِثِينَ. [الأنبياء - 89]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [المؤمنون - 97-98].",
      content:
        " رَّبِّ أَعُوذُ بِكَ مِنْ هَمَزَاتِ الشَّيَاطِينِ وَأَعُوذُ بِكَ رَبِّ أَن يَحْضُرُونِ. [المؤمنون - 97-98]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [المؤمنون - 109].",
      content:
        " رَبَّنَا آمَنَّا فَاغْفِرْ لَنَا وَارْحَمْنَا وَأَنتَ خَيْرُ الرَّاحِمِينَ. [المؤمنون - 109]. ",
    },
    {
      category: "أدعية قرآنية",
      count: "01",
      description: "",
      reference: ". [المؤمنون - 118].",
      content:
        " رَّبِّ اغْفِرْ وَارْحَمْ وَأَنتَ خَيْرُ الرَّاحِمِينَ. [المؤمنون - 118]. ",
    },
  ],
  "أدعية الأنبياء": [
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "آدم علية السلام.",
      reference: ". [الأعراف - 23].",
      content:
        " رَبَّنَا ظَلَمْنَا أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ. [الأعراف - 23]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "نوح علية السلام.",
      reference: ". [نوح - 28].",
      content:
        " رَّبِّ اغْفِرْ لِي وَلِوَالِدَيَّ وَلِمَن دَخَلَ بَيْتِيَ مُؤْمِنًا وَلِلْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ وَلَا تَزِدِ الظَّالِمِينَ إِلَّا تَبَارًا. [نوح - 28].رَبِّ إِنِّي أَعُوذُ بِكَ أَنْ أَسْأَلَكَ مَا لَيْسَ لِي بِهِ عِلْمٌ وَإِلاَّ تَغْفِرْ لِي وَتَرْحَمْنِي أَكُن مِّنَ الْخَاسِرِينَ. [هود - 47]. رَّبِّ أَنزِلْنِي مُنزَلاً مُّبَارَكاً وَأَنتَ خَيْرُ الْمُنزِلِينَ. [المؤمنون - 29]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "إبراهيم علية السلام.",
      reference: ". [هود - 47].",
      content:
        " رَبَّنَا تَقَبَّلْ مِنَّا إِنَّكَ أَنْتَ السَّمِيعُ الْعَلِيمُ (127) رَبَّنَا وَاجْعَلْنَا مُسْلِمَيْنِ لَكَ وَمِنْ ذُرِّيَّتِنَا أُمَّةً مُسْلِمَةً لَكَ وَأَرِنَا مَنَاسِكَنَا وَتُبْ عَلَيْنَا إِنَّكَ أَنْتَ التَّوَّابُ الرَّحِيمُ (128). [البقرة - 127-128]. رَبِّ اجْعَلْنِي مُقِيمَ الصَّلَاةِ وَمِن ذُرِّيَّتِي ۚ رَبَّنَا وَتَقَبَّلْ دُعَاءِ (40) رَبَّنَا اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ (41). [إبراهيم - 40-41]. رَبِّ هَبْ لِي حُكْمًا وَأَلْحِقْنِي بِالصَّالِحِينَ (83) وَاجْعَل لِّي لِسَانَ صِدْقٍ فِي الْآخِرِينَ (84) وَاجْعَلْنِي مِن وَرَثَةِ جَنَّةِ النَّعِيمِ (85). [الشعراء - 83-85]. رَّبَّنَا عَلَيْكَ تَوَكَّلْنَا وَإِلَيْكَ أَنَبْنَا وَإِلَيْكَ الْمَصِيرُ (4) رَبَّنَا لَا تَجْعَلْنَا فِتْنَةً لِّلَّذِينَ كَفَرُوا وَاغْفِرْ لَنَا رَبَّنَا ۖ  إِنَّكَ أَنتَ الْعَزِيزُ الْحَكِيمُ (5). [الممتحنة - 4-5]. رَبِّ هَبْ لِي مِنَ الصَّالِحِينَ. [الصافات - 100]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "هود علية السلام.",
      reference: ". [المؤمنون - 29].",
      content:
        " إِنِّي تَوَكَّلْتُ عَلَى اللَّهِ رَبِّي وَرَبِّكُم ۚ مَّا مِن دَابَّةٍ إِلَّا هُوَ آخِذٌ بِنَاصِيَتِهَا ۚ إِنَّ رَبِّي عَلَىٰ صِرَاطٍ مُّسْتَقِيمٍ. [هود - 56]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "لوط علية السلام.",
      reference: ". [البقرة - 127-128].",
      content:
        " رَبِّ انْصُرْنِي عَلَى الْقَوْمِ الْمُفْسِدِينَ. [العنكبوت - 30]. رَبِّ نَجِّنِي وَأَهْلِي مِمَّا يَعْمَلُونَ. [الشعراء - 169]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "يوسف علية السلام.",
      reference: ". [إبراهيم - 40-41].",
      content:
        " فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ أَنتَ وَلِيِّي فِي الدُّنْيَا وَالْآخِرَةِ ۖ تَوَفَّنِي مُسْلِمًا وَأَلْحِقْنِي بِالصَّالِحِينَ. [يوسف - 101]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "شعيب علية السلام.",
      reference: ". [الشعراء - 83-85].",
      content:
        " وَسِعَ رَبُّنَا كُلَّ شَيْءٍ عِلْماً عَلَى اللّهِ تَوَكَّلْنَا رَبَّنَا افْتَحْ بَيْنَنَا وَبَيْنَ قَوْمِنَا بِالْحَقِّ وَأَنتَ خَيْرُ الْفَاتِحِينَ. [الأعراف - 89]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "موسى علية السلام.",
      reference: ". [الممتحنة - 4-5].",
      content:
        " رَبِّ إِنِّي ظَلَمْتُ نَفْسِي فَاغْفِرْ لِي. [القصص - 16]. رَبِّ بِمَا أَنْعَمْتَ عَلَيَّ فَلَنْ أَكُونَ ظَهِيراً لِّلْمُجْرِمِينَ. [القصص - 17]. رَبِّ إِنِّي لِمَا أَنزَلْتَ إِلَيَّ مِنْ خَيْرٍ فَقِيرٌ. [القصص - 24]. رَبِّ اشْرَحْ لِي صَدْرِي (25) وَيَسِّرْ لِي أَمْرِي (26) وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي (27) يَفْقَهُوا قَوْلِي (28). [طه - 25-28]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "أيوب علية السلام.",
      reference: ". [الصافات - 100].",
      content:
        " أَنِّي مَسَّنِيَ الضُّرُّ وَأَنتَ أَرْحَمُ الرَّاحِمِينَ. [الأنبياء - 83]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "سليمان علية السلام.",
      reference: ". [هود - 56].",
      content:
        " رَبِّ أَوْزِعْنِي أَنْ أَشْكُرَ نِعْمَتَكَ الَّتِي أَنْعَمْتَ عَلَيَّ وَعَلَى وَالِدَيَّ وَأَنْ أَعْمَلَ صَالِحًا تَرْضَاهُ وَأَدْخِلْنِي بِرَحْمَتِكَ فِي عِبَادِكَ الصَّالِحِينَ. [النمل - 19]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "يونس علية السلام.",
      reference: ". [العنكبوت - 30].",
      content:
        "لَّا إِلَهَ إِلَّا أَنتَ سُبْحَانَكَ إِنِّي كُنتُ مِنَ الظَّالِمِينَ. [الأنبياء - 87]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "زكريا علية السلام.",
      reference: ". [الشعراء - 169].",
      content:
        " رَبِّ هَبْ لِي مِن لَّدُنْكَ ذُرِّيَّةً طَيِّبَةً إِنَّكَ سَمِيعُ الدُّعَاء. [آل عمران - 38]. رَبِّ لَا تَذَرْنِي فَرْداً وَأَنتَ خَيْرُ الْوَارِثِينَ. [الأنبياء - 89]. ",
    },
    {
      category: "أدعية الأنبياء",
      count: "01",
      description: "يعقوب علية السلام.",
      reference: ". [يوسف - 101].",
      content:
        " إِنَّمَا أَشْكُو بَثِّي وَحُزْنِي إِلَى اللَّهِ. [يوسف - 86]. ",
    },
  ],
};
export default azkarData;
